import React, { useEffect, useState } from "react";
import "../style.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { icon } from "@fortawesome/fontawesome-svg-core/import.macro";
import logo from "../img/logo.png";
import SideNav from "components/SideNav";
import { collection, query, where, getDocs, orderBy } from "firebase/firestore";
import { doc, updateDoc, deleteDoc } from "firebase/firestore";
import { db, storage } from "../firebase/firebase";
import { getAuth } from "firebase/auth";
import { Button } from "react-bootstrap";
import profile from "../img/profile.png";
import UserPage from "components/user/Userpage.tsx";

export default function Users() {
  const [isLoading, setIsLoading] = useState(true);
  const [users, setUsers] = useState([]);

  // useEffect(() => {
  //   loadUsers();
  // }, []);

  const Content = () => (
    <section className="home-section">
      <div className="text">User</div>

      <div style={{ backgroundColor: "#ecf5ff", width: "100%" }}>
        {UserPage()}
      </div>

      {/* plans */}
      {/* <section style={{ paddingTop: 50 }} className="my-plans" id="plans">
        <div>
          {isLoading ? (
            <div style={{ marginBottom: 10, fontSize: 30 }}>Laden...</div>
          ) : (
            <>
          
              <RenderUsers></RenderUsers>
            </>
          )}
        </div>
      </section> */}
    </section>
  );

  const loadUsers = async () => {
    const q = query(collection(db, "users"), orderBy("username"));

    const querySnapshot = await getDocs(q);

    var help = [];

    querySnapshot.forEach((doc) => {
      help.push(doc);
    });

    setUsers(help);

    setIsLoading(false);
  };

  const selPage = "users";

  function RenderUsers() {
    var help = [];

    users.map((data) => {
      var obj = data.data();
      var refString = "edituser?userid=" + data?.id; //+ doc.id;

      if (obj.username != undefined)
        help.push(
          <a
            href={refString}
            style={{
              cursor: "pointer",
              marginBottom: "20px",
              color: "#000",
            }}
          >
            <div style={{ height: 5 }}></div>

            <ul
              className="flex-row"
              style={{
                alignItems: "center",
                gap: 0,
                paddingTop: 15,
                paddingBottom: 15,
                paddingLeft: 15,
              }}
            >
              <li>
                {obj.photoUrl ? (
                  <img
                    style={{
                      width: 45,
                      height: 45,
                      marginRight: 20,
                      borderRadius: 90,
                      objectFit: "cover",
                    }}
                    src={obj.photoUrl}
                    alt=""
                  ></img>
                ) : (
                  <img
                    style={{
                      width: 45,
                      height: 45,
                      marginRight: 20,
                    }}
                    src={profile}
                    alt=""
                  ></img>
                )}
              </li>
              <li>
                <h1 style={{ paddingBottom: 0 }}>
                  <a
                    style={{
                      cursor: "pointer",
                      // marg inBottom: "20px",
                      color: "#000",
                    }}
                  >
                    {obj.username + "\n"}
                  </a>
                </h1>
                <a
                  style={{
                    // marginBottom: "20px",
                    color: "#4b5467",
                  }}
                >
                  {obj.mail ? obj.mail + "\n" : "-" + "\n"}
                </a>
              </li>
            </ul>

            <div style={{ height: 5 }}></div>
            <div
              style={{
                width: "95%",
                height: 1,
                backgroundColor: "#777",
                marginLeft: "2.5%",
                marginRight: "2.5%",
              }}
            ></div>
          </a>
        );
    });

    return <>{help}</>;
  }

  return (
    <>
      <head>
        <link
          href="https://unpkg.com/boxicons@2.0.7/css/boxicons.min.css"
          rel="stylesheet"
        />
      </head>

      {SideNav({
        Content,
        selPage,
      })}
    </>
  );
}
